import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import '../index.css';

const Register = () => {
    let {token} = useParams();

    const [loadingData, setLoadingData] = useState(true);

    const [inputs, setInputs] = useState({});
   
    useEffect(() => {
        async function getData(){
            await axios.get(`https://innounita.univ-unita.eu/backend/companies/register/${token}`)
            .then((response) => {
                setInputs(response.data)
                setLoadingData(false)
            });
        }
        if (loadingData) {
             getData();
        }
    },[]);

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setInputs(values => ({...values, [name]: value}))
    }

    

    const handleSubmit = (e) => {
        e.preventDefault();
        // const edit = {  data }
        if(inputs.password != inputs.matchPassword){
            alert("Passwords don't match!")
            return;
        }
        if(inputs.password.length < 6){
            alert("Password is too short, required 6+ characters!")
            return;
        }
        axios.post(`https://innounita.univ-unita.eu/backend/companies/register/${token}`,inputs)
        .then(()=>{
            window.location = "/login";
            alert("Register successful!")
        })
        .catch(function (error) {
            console.log(error);
          });
       
        // history.go(-1);
        // history.push('/companies');
    }

    return (
        <div className="login-body">
            <div className="ui container">
                <div className="login-background">
                    <div className="ui left aligned container login-field">
                        <form className="ui form" onSubmit={handleSubmit}>
                            <div style={{ "textAlign" : "center" }}><h1>Welcome</h1></div>
                            <label>Email</label>
                            <input type="text" name='username' value={inputs.username|| ""}  onChange={handleChange} disabled />
                            <label>Password</label>
                            <input type="password" name='password'  onChange={handleChange} />
                            <label>Confirm Password</label>
                            <input type="password" name='matchPassword' onChange={handleChange} />
                            <br/><br/>
                            <div className="login-button">
                                <button className="ui button primary">Register</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        );
}


export default Register;